
/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.5.26
 */
let { isArray } = T;
let {
  divIcon,
  featureGroup,
  layerGroup,
  marker: toMarker,
  Polyline,
  Polygon,
  Circle,
  latLng: toLatLng,
  Path
} = L;

let editLayer;
Path.include({
  /**
    * 绘制编辑拖动点
    * @param v 
    */
  toEdit() {
    let marker = this;
    let latlngs, onDrag, vLatLngs;
    let { _map: map } = this;
    if (!editLayer || !map.hasLayer(editLayer)) {
      //添加编辑图层
      editLayer = L.layerGroup().addTo(map);
      map.on('preclick zoomend moveend', () => { editLayer.clearLayers() });
      marker.dragging.enable();//确保可拖动，即使初始化options.draggable=true，不能确保dragstart可触发
      marker.on('dragstart', () => { editLayer.clearLayers() })
    }
    let layer = this.editLayer = editLayer;
    layer.clearLayers();
    if (marker instanceof Polygon) {
      latlngs = marker.getLatLngs()[0];
      vLatLngs = []
      for (let i = 0, l = latlngs.length, item, next; i < l; i++) {
        item = latlngs[i];
        if (i < l - 1) {
          next = latlngs[i + 1];
        } else {
          next = latlngs[0];
        }
        vLatLngs.push([(item.lat + next.lat) * 0.5, (item.lng + next.lng) * 0.5]);
      }
    } else if (marker instanceof Circle) {
      let bounds = marker.getBounds();
      let center = marker.getLatLng();
      latlngs = [[bounds.getNorth(), center.lng], [bounds.getSouth(), center.lng], [center.lat, bounds.getWest()], [center.lat, bounds.getEast()]]
      onDrag = this.onCirclePointDrag;
    } else if (marker.getLatLngs) {//点图元 没有marker.getLatLngs 的方法。
      latlngs = marker.getLatLngs();
      vLatLngs = [];
      for (let i = 0, l = latlngs.length - 1, item, next; i < l; i++) {
        item = latlngs[i];
        next = latlngs[i + 1];
        vLatLngs.push([(item.lat + next.lat) * 0.5, (item.lng + next.lng) * 0.5])
      }
    }
    onDrag = onDrag || this.onLinePointDrag;
    if (latlngs) {
      let linePointStyle = {
        icon: divIcon({ className: 'linePoint' }), draggable: true, clickable: false
      }
      latlngs.forEach(value => {
        toMarker(value, linePointStyle).on('drag', onDrag.bind(this)).addTo(layer)
      })
      if (vLatLngs) {
        linePointStyle = T.assign(linePointStyle, { icon: divIcon({ className: 'vlinePoint' }) })
        vLatLngs.forEach((value, index) => {
          let linePoint = toMarker(value, linePointStyle).on('mousedown', e => {
            let { latlng } = e;
            let latlngs = marker.getLatLngs();
            if (marker instanceof Polygon) {
              latlngs = latlngs[0];
            }
            latlngs.splice(index + 1, 0, latlng);
            marker.setLatLngs(latlngs);
            linePoint.on('drag', e => {
              latlngs[index + 1] = e.latlng;
              marker.setLatLngs(latlngs);
              marker.redraw();
            }).on('mouseup dragend', e => {
              this.toEdit();
            })
          })
          layer.addLayer(linePoint);
        })
      }
    }
  },
  /**
  * 线图元进行拖动
  * @param e 
  */
  onLinePointDrag(e) {
    let marker = this;
    if (marker) {
      let points = this.editLayer.getLayers(),
        { target, latlng } = e,
        index = points.indexOf(target),
        latlngs = marker.getLatLngs();
      if (isArray(latlngs[0])) {
        latlngs = latlngs[0]
      }
      let num = latlngs.length,
        vindex = index + num,
        last = index === 0 ? num - 1 : index - 1,
        next = (index === num - 1) ? 0 : index + 1,
        vlast = points[last + num],
        vnext = points[next ? (next + num - 1) : points.length - 1]
      last = latlngs[last];
      next = latlngs[next];
      if ((index !== 0 && index !== num - 1) || marker instanceof Polygon) {
        vlast.setLatLng([(last.lat + latlng.lat) * 0.5, (last.lng + latlng.lng) * 0.5])
        vnext.setLatLng([(next.lat + latlng.lat) * 0.5, (next.lng + latlng.lng) * 0.5])
      } else {
        if (index === 0) {
          vnext.setLatLng([(next.lat + latlng.lat) * 0.5, (next.lng + latlng.lng) * 0.5])
        } else {
          vlast.setLatLng([(last.lat + latlng.lat) * 0.5, (last.lng + latlng.lng) * 0.5])
        }
      }
      //
      latlngs[index] = latlng
      marker.setLatLngs(latlngs)
      // marker.redraw();
    }
  },
  /**
   * 线图元进行拖动
   * @param e 
   */
  onCirclePointDrag(e) {
    let marker = this;
    let latlng = e.latlng,
      center = marker.getLatLng(),
      r = latlng.distanceTo(center);
    marker.setRadius(r);
    marker.redraw();
    let bounds = marker.getBounds(),
      north = bounds.getNorth(),
      south = bounds.getSouth(),
      west = bounds.getWest(),
      east = bounds.getEast();
    let points = this.editLayer.getLayers();
    points[0].setLatLng(toLatLng(north, center.lng))
    points[1].setLatLng(toLatLng(south, center.lng))
    points[2].setLatLng(toLatLng(center.lat, west))
    points[3].setLatLng(toLatLng(center.lat, east))
  },
  editEnable() {
    this.options.editable = true;
    this.on('click', this.toEdit.bind(this))
  }
})

L.Path.addInitHook(function () {
  this.options.editable && this.editEnable();
})



// WEBPACK FOOTER //
// ./src/polyfill/Editable.js